import React, { useContext } from "react";
import { Link } from "react-router-dom";
// Language
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

const GiftCardBanner = () => {
  const { language } = useContext(LanguageContext);
  const translations = language === "en" ? en.home : no.home;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-main-dark text-main-light p-4 text-center z-[999] w-full">
      <p className="font-copy text-sm md:text-base m-0">
        <Link to="/giftcards" className="text-inherit no-underline hover:underline">
          {translations.giftCardBanner}
        </Link>
      </p>
    </div>
  );
};

export default GiftCardBanner;
